import React, { useEffect, useState } from "react";
import { Modal, Offcanvas } from "react-bootstrap";

export default function MyModal({
  label,
  className,
  buttonClassName,
  disabled,
  title,
  modalClassName,
  backdropClassName,
  heading,
  children,
  size,
  centered,
  onShow,
  as = "modal",
  show: controlledShow,
  onHide,
  initialShow = false,
  fullscreen,
}: {
  label?: string | React.ReactNode;
  className?: string;
  buttonClassName?: string;
  disabled?: boolean;
  title?: string;
  modalClassName?: string;
  backdropClassName?: string;
  heading: string | React.ReactNode;
  children:
    | React.ReactNode
    | (({ handleClose }: { handleClose: () => void }) => React.ReactNode);
  size?: "xxl" | "xl" | "sm" | "lg" | undefined;
  centered?: boolean;
  onShow?: () => void;
  as?: "modal" | "offcanvas";
  show?: boolean;
  onHide?: () => void;
  initialShow?: boolean;
  fullscreen?: true | string | undefined;
}) {
  const [show, setShow] = useState(controlledShow ?? initialShow);
  useEffect(() => {
    if (controlledShow !== undefined) setShow(controlledShow);
  }, [controlledShow]);

  const handleClose = () => {
    setShow(false);
    onHide?.();
  };
  const handleShow = async () => {
    await onShow?.();
    setShow(true);
  };

  const Element = as === "offcanvas" ? Offcanvas : Modal;

  return (
    <div
      className="d-inline-block"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <button
        type="button"
        className={`btn p-0 border-0 h-100 ${buttonClassName}`}
        onClick={(e) => {
          handleShow();
          e.stopPropagation();
        }}
        disabled={disabled}
      >
        {label}
      </button>

      <Element
        show={show}
        onHide={handleClose}
        size={size as any}
        enforceFocus={false}
        scrollable
        contentClassName={modalClassName}
        className={className}
        backdropClassName={backdropClassName}
        centered={centered}
        placement={as === "offcanvas" ? "end" : undefined}
        style={as === "offcanvas" ? { width: "600px" } : {}}
        fullscreen={fullscreen}
      >
        <Element.Header closeButton>
          <Element.Title>{heading}</Element.Title>
        </Element.Header>
        <Element.Body>
          {typeof children === "function"
            ? children({ handleClose })
            : children}
        </Element.Body>
      </Element>
    </div>
  );
}
